// extracted by mini-css-extract-plugin
export var blogPost = "BlogPost-module--blog-post--Igi-M";
export var textContainer = "BlogPost-module--text-container--Sd8UU";
export var titleContainer = "BlogPost-module--title-container--l5vld";